import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(() => ({
  '@keyframes jello': {
    from: { transform: 'translate3d(0, 0, 0)' },
    '11.1%': { transform: 'translate3d(0, 0, 0)' },
    to: { transform: 'translate3d(0, 0, 0)' },
    '22.2%': {
      transform: 'skewX(-12.5deg) skewY(-12.5deg)',
    },

    '33.3%': {
      transform: 'skewX(6.25deg) skewY(6.25deg)',
    },

    '44.4%': {
      transform: 'skewX(-3.125deg) skewY(-3.125deg)',
    },

    '55.5%': {
      transform: 'skewX(1.5625deg) skewY(1.5625deg)',
    },

    '66.6%': {
      transform: 'skewX(-0.78125deg) skewY(-0.78125deg)',
    },

    '77.7%': {
      transform: 'skewX(0.390625deg) skewY(0.390625deg)',
    },

    '88.8%': {
      transform: 'skewX(-0.1953125deg) skewY(-0.1953125deg)',
    },
  },

  '@keyframes fade-in': {
    from: {
      opacity: 0,
      visibility: 'hidden',
    },
    to: {
      opacity: 1,
      visibility: 'visible',
    },
  },

  '@keyframes fade-out': {
    from: {
      opacity: 1,
      visibility: 'visible',
    },
    to: {
      opacity: 0,
      visibility: 'hidden',
    },
  },

  splashScreen: {
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 1,
    backgroundColor: '#FF8000',
    zIndex: 9999,
  },
  splashScreenElement: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  splashScreenLogo: {
    animation: `$jello 1s infinite`,
    transformOrigin: 'center',
    width: '70px',
    height: '70px',
    display: 'block',
    '& img': {
      display: 'block',
      width: '100%',
      height: '100%',
    },
  },
  splashScreenLogoText: {
    display: 'block',
    width: '217px',
    marginTop: '10px',
    '& img': {
      width: '217px',
      height: '37px',
    },
  },
}));

export default styles;
